<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <router-link class="btn btn-info" :to="{name: 'orders.medias.add'}">افزودن متن / تصویر</router-link>
            <hr class="mb-3">
            <nav class="nav nav-tabs mb-2">
                <a class="nav-link ml-1 active" data-toggle="tab" @click="setCurrentTab('photos')" href="#photos">تصاویر</a>
                <a class="nav-link" v-if="$store.state.role == 'admin'" data-toggle="tab" @click="setCurrentTab('texts')" href="#texts">متن ها</a>
            </nav>
            <div class="tab-content">
                <div class="tab-pane active show" id="photos">
                    <div class="row" v-if="photos.length">
                        <div class="col-md-2 mt-3 text-center" v-for="(item,index) in photos" :key="index">
                            <div class="thun-img-parent mb-3">
                                <img :src="`https://cardapi.sabinarya.com/${item.picUrl}`">
                            </div>
                            <p v-if="item.domainData">سازمان : {{ item.domainData.fullName }}</p>
                            <div class="btn-icon-list justify-content-center" v-if="item.isApproved == 2 || item.isApproved == 3">
                                <button class="btn btn-icon btn-info ml-2" data-toggle="modal" @click="currentMediaId = item.mediaId" data-target="#comments"><i class="ti-comment"></i></button>
                                <button class="btn btn-icon btn-success ml-2" @click="approveOrReject(true,item.mediaId)"><i class="fe fe-check"></i></button>
                                <button class="btn btn-icon btn-danger" data-toggle="modal" @click="currentMediaId = item.mediaId" data-target="#reject-image"><i class="fe fe-x"></i></button>
                            </div>
                            <div class="btn-icon-list justify-content-center" v-else>
                                <button class="btn btn-icon btn-info ml-2" data-toggle="modal" @click="currentMediaId = item.mediaId" data-target="#comments"><i class="ti-comment"></i></button>
                                <p class="mt-3 mb-2" style="font-size: 21px" v-if="item.isApproved == 1"><i class="text-success fe fe-check"></i></p>
                                <p class="mt-3 mb-2" style="font-size: 21px" v-if="item.isApproved == 0"><i class="text-danger fe fe-x"></i></p>
                                <p class="mt-3 mb-2" style="font-size: 21px" v-if="item.isApproved == 2 || item.isApproved == 3"><i class="text-primary ti-timer"></i></p>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-12">
                            <div class="alert alert-info mb-0">
                                <p class="mb-0">تصویر جهت تایید یافت نشد</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal effect-scale" id="comments" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content modal-content-demo">
                                <div class="modal-header">
                                    <h6 class="modal-title">مکاتبات</h6>
                                    <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                </div>
                                <div class="modal-body">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>پیام</label>
                                            <textarea rows="2" class="form-control" v-model="comment"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-4">
                                        <button class="btn btn-success" :disabled="comment.length < 1" @click="addComment" data-dismiss="modal">ثبت پیام جدید</button>
                                    </div>
                                    <hr v-if="comments.length">
                                    <h6 v-if="comments.length" class="mb-4 mt-4">پیام های قبلی :</h6>
                                    <div class="card mb-2" v-for="(comment,index) in comments" :key="index">
                                        <div class="card-header">
                                            <div class="card-title">{{ comment.userType }} ({{ comment.userFullName }})</div>
                                        </div>
                                        <div class="card-body">
                                            <p>{{ comment.description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal effect-scale" id="reject-image" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content modal-content-demo">
                                <div class="modal-header">
                                    <h6 class="modal-title">علت عدم تایید</h6>
                                    <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>توضیحات</label>
                                                <textarea rows="4" class="form-control" v-model="description"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <button class="btn btn-success" :disabled="!description" @click="approveOrReject(false)" data-dismiss="modal">ثبت عدم تایید</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="texts">
                    <div class="row" v-if="texts.length">
                        <div class="col-md-3 mt-3" v-for="(item,index) in texts" :key="index">
                            <p>{{ item.text }}</p>
                            <p v-if="item.domainData">سازمان : {{ item.domainData.fullName }}</p>
                            <p class="btn-icon-list" v-if="item.isApproved == 2">
                                <button class="btn btn-icon btn-success ml-2" @click="approveOrReject(true,item.mediaId)"><i class="fe fe-check"></i></button>
                                <button class="btn btn-icon btn-danger" @click="approveOrReject(false,item.mediaId)"><i class="fe fe-x"></i></button>
                            </p>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-12">
                            <div class="alert alert-info mb-0">
                                <p class="mb-0">تصویر جهت تایید یافت نشد</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            showLoading: true,
            currentTab: 'photos',
            description: '',
            currentMediaId: 0,
            comment: '',
            comments: [],
            all: [],
            photos: [],
            texts: []
        }
    },
    watch: {
        currentMediaId(value){
            if(value){
                this.comments = [];
                let media = this.all.filter(item => item.mediaId == value);
                if(media.length){
                    media = media[0];
                    this.comments = media.mediaLogs || [];
                }
            }
        }
    },
    methods: {
        approveOrReject(approve,mediaId = null){
            this.showLoading = true;
            if(mediaId == null)
                mediaId = this.currentMediaId;
            const postedData = {
                approveList: [
                    {
                        mediaId,
                        approve,
                        comment: this.description
                    }
                ]
            };
            this.$api.post('Organizations/Media/Approve',postedData).then(({data}) => {
                if(data.status){
                    this.description = '';
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: (approve ? 'تایید' : 'عدم تایید') + ' با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getData(){
            this.showLoading = true;
            let url = 'Organizations/Media?Option=' + (this.$store.state.role == 'bankpublicrelations' ? 4 : 3);
            this.$api.get(url).then(({data}) => {
                this.all = data.result;
                this.photos = data.result.filter(item => item.metadataKeyId == 2);
                this.texts = data.result.filter(item => item.metadataKeyId == 3);
            }).finally(() => {
                this.showLoading = false;
            });
        },
        setCurrentTab(tab){
            this.currentTab = tab;
        },
        addComment(){
            this.showLoading = true;
            const postedData = {
                mediaId: this.currentMediaId,
                comment: this.comment
            }
            this.$api.post('Organizations/Media/AddCommnet',postedData).then(({data}) => {
                this.currentMediaId = 0;
                this.comment = '';
                this.getData();
                this.$swal({
                    title: 'تبریک',
                    icon: 'success',
                    text: 'پیا جدید با موفقیت ثبت شد',
                    confirmButtonText: 'متوجه شدم'
                });
            }).finally(() => {
                this.showLoading = false;
            })
        }
    },
    created(){
        this.getData();
    }
}
</script>